export enum MessageDirection {
  incoming,
  outgoing,
  system = 3,
}
